// ---------------------------------------------------------------------------
// Colour helpers
// ---------------------------------------------------------------------------
const ORANGE = [255, 140, 0];
const BLUE = [30, 60, 255];
const WHITE = [255, 255, 255];
function lerp(a, b, t) {
    return a + (b - a) * t;
}
export function distanceToHeatmapColor(t) {
    const c = Math.min(1, Math.max(0, t));
    return [
        Math.round(lerp(ORANGE[0], BLUE[0], c)),
        Math.round(lerp(ORANGE[1], BLUE[1], c)),
        Math.round(lerp(ORANGE[2], BLUE[2], c)),
    ];
}
/** 95th-percentile of a numeric array. */
function percentile95(values) {
    if (values.length === 0)
        return 1;
    const sorted = [...values].sort((a, b) => a - b);
    const idx = Math.floor(sorted.length * 0.95);
    return sorted[Math.min(idx, sorted.length - 1)];
}
// ---------------------------------------------------------------------------
// Public builders
// ---------------------------------------------------------------------------
export function buildRoomNumberingHeatmapEdges(graph, distMap) {
    const nodePos = new Map(graph.nodes.map((n) => [n.id, [n.posM[0], n.posM[1]]]));
    const finiteDists = [...distMap.values()].map((e) => e.dist).filter(Number.isFinite);
    const p95 = percentile95(finiteDists);
    const edges = [];
    for (const edge of graph.edges) {
        const fPos = nodePos.get(edge.from);
        const tPos = nodePos.get(edge.to);
        if (!fPos || !tPos)
            continue;
        const dFrom = distMap.get(edge.from)?.dist;
        const dTo = distMap.get(edge.to)?.dist;
        const hasDistance = dFrom !== undefined && Number.isFinite(dFrom) &&
            dTo !== undefined && Number.isFinite(dTo);
        const color = hasDistance
            ? distanceToHeatmapColor(Math.min(((dFrom + dTo) / 2) / p95, 1))
            : [51, 51, 68];
        edges.push({
            id: `heatmap-edge-${edge.id}`,
            points: [fPos, tPos],
            color,
            hasDistance,
        });
    }
    return edges;
}
const NODE_RADIUS_M = 0.16;
export function buildRoomNumberingHeatmapNodes(graph, distMap) {
    const finiteDists = [...distMap.values()].map((e) => e.dist).filter(Number.isFinite);
    const p95 = percentile95(finiteDists);
    const nodes = [];
    for (const node of graph.nodes) {
        const entry = distMap.get(node.id);
        if (!entry || !Number.isFinite(entry.dist))
            continue;
        const isStaircase = entry.dist === 0;
        const t = Math.min(entry.dist / p95, 1);
        nodes.push({
            id: `heatmap-node-${node.id}`,
            position: [node.posM[0], node.posM[1]],
            color: isStaircase ? WHITE : distanceToHeatmapColor(t),
            radiusM: NODE_RADIUS_M,
        });
    }
    return nodes;
}
